export default "__VITE_ASSET__DzAQvksy__"